//#region ../r-html/dist/helpers/subject.js
function createSubject() {
	const observers = /* @__PURE__ */ new Set();
	const subscribe = (fn) => {
		observers.has(fn) || observers.add(fn);
		return () => {
			observers.delete(fn);
		};
	};
	const next = (value) => {
		observers.forEach((fn) => fn(value));
	};
	const asReadonly = () => ({ subscribe });
	return {
		subscribe,
		next,
		asReadonly
	};
}
//#endregion
export { createSubject };
